import React, { useState } from 'react'
import { closeModal, facebook, galochka, instagram, telegram } from '../../../assets'
import AvatarImage from './../../../components/avatarImage'
import { FileInput, GlobalInput } from '../../../components/Generic'
import { Link } from 'react-router-dom'

const EditProfile = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    
  // modal opener
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeLang = () => {
    setIsModalOpen(false);
  };

  return (
    <div className='mb-[100px]'>
        <div className="flex justify-around items-center w-full mt-[60px] mb-[40px] sm:mb-[30px] md:mt-10">
            <Link to={'/user'}><img className='w-[18px] h-[18px] sm:w-[25px] sm:h-[25px] cursor-pointer' src={closeModal} alt="" /></Link>
            <div className='text-[16px] text-normal font-inter sm:text-[20px]'>Edit profile</div>
            <Link to={'/user'}><img className='w-[18px] h-[18px] sm:w-[25px] sm:h-[25px] cursor-pointer' src={galochka} alt="" /></Link>
        </div>
        <div className='flex flex-col sm:flex-row gap-[40px] h-full'>
        <div className=' md:ml-[40px] flex justify-center items-center sm:items-start flex-col gap-[24px] sm:mb-[20px]'>
            <AvatarImage style={`w-[80px] h-[80px] sm:w-[200px] sm:h-[200px]`} />
            <FileInput>
            <div className='text-blue-chatBlue text-[17px] font-inter sm:text-[21px] cursor-pointer'>Change profile photo</div>
            </FileInput>
        </div>
        <div className='flex flex-col gap-[20px] sm:mt-[30px] max-w-[393px]  mx-[18px] md:w-[600px]'>
            <GlobalInput value={'Name'}/>
            <GlobalInput value={'Username'}/>
            <GlobalInput value={'Bio'}/>
            <GlobalInput value={'Phone number'}/>
            <div className='relative'>
            <div onClick={openModal} className='text-gray-inputsGray pb-[5px] cursor-pointer border-b-[1px] border-solid border-gray-borderinGray text-[15px]'>Add links</div>
            {
                !isModalOpen ? null :
           ( <div className='px-[20px] pt-[20px] pb-[8px] rounded-[5px] flex flex-col items-end absolute bg-[white] bottom-0 left-[50px]'>
                <div className='flex flex-col gap-[5px]'>
                <div className='flex items-center gap-[15px]'>
                    <div><img src={telegram} alt="" /></div>
                    <div><GlobalInput style={`text-[13px] w-[219px] text-gray-inputsGray`} value={'Telegram link'}/></div>
                </div>
                <div className='flex  items-center gap-[15px]'>
                    <div><img src={instagram} alt="" /></div>
                    <div><GlobalInput style={`text-[13px] w-[219px] text-gray-inputsGray`} value={'Instagram link'}/></div>
                </div>
                <div className='flex items-center gap-[15px]'>
                    <div><img src={facebook} alt="" /></div>
                    <div><GlobalInput style={`text-[13px] w-[219px] text-gray-inputsGray`} value={'Facebook link'}/></div>
                </div>
                </div>
                <div onClick={closeLang} className='text-[11px] cursor-pointer sm:text-[14px] text-blue-chatBlue pt-[8px]'>Save</div>
            </div>)
            }
            </div>
        </div>
        </div>
    </div>
  )
}

export default EditProfile